import { useConfig } from "./ConfigProvider";

import "./Header.scss";

const Header = () => {
  const config = useConfig();

  const logo = <img className="header-logo" src={config.header.logo} alt={config.companyName} />;

  return (
    <header className="Header">
      <h1 style={{ flexDirection: "row", justifyContent: "flex-start", alignItems: "center", padding: ".5rem 1rem" }}>
        {config.header.urlLogo ? (
          <a href={config.header.urlLogo} style={{ display: "flex", alignItems: "center" }}>
            {logo}
          </a>
        ) : (
          logo
        )}
        <small style={{ fontSize: "1.25rem", fontWeight: "800" }}>{config.header.title}</small>
      </h1>
    </header>
  );
};

export default Header;
